export default {
  useNextVariants: true,
  fontFamily: "'ItauText-Regular', sans-serif",
  fontSize: 16,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
};
